import type { ImprintKind } from "@/types/domain"

export const imprintKinds: ImprintKind[] = ["BARCA", "WHITE_LABEL"]

export const imprintKindLabels: Record<ImprintKind, string> = {
  BARCA: "Selo da Barca",
  WHITE_LABEL: "White label",
}

/** Rótulos no plural, usados nos filtros. */
export const imprintKindFilterLabels: Record<ImprintKind, string> = {
  BARCA: "Selos da Barca",
  WHITE_LABEL: "Selos White Label",
}

const paramByKind: Record<ImprintKind, string> = { BARCA: "barca", WHITE_LABEL: "white-label" }

/** Lê o parâmetro `tipo` da URL; valores desconhecidos significam "todos". */
export function imprintKindFromParam(value: string | null): ImprintKind | undefined {
  return imprintKinds.find((kind) => paramByKind[kind] === value)
}

export function imprintKindParam(kind?: ImprintKind) {
  return kind ? paramByKind[kind] : ""
}

/** Selos antigos sem tipo informado contam como Selo da Barca. */
export function imprintKindOf(imprint: { kind?: ImprintKind }): ImprintKind {
  return imprint.kind ?? "BARCA"
}

export function matchesImprintKind(imprint: { kind?: ImprintKind }, kind?: ImprintKind) {
  return !kind || imprintKindOf(imprint) === kind
}

/** Ordem das listas de selos: Selos da Barca primeiro, depois os white label, cada grupo em ordem alfabética. */
export function compareImprintKinds(left: { kind?: ImprintKind }, right: { kind?: ImprintKind }) {
  return Number(imprintKindOf(left) === "WHITE_LABEL") - Number(imprintKindOf(right) === "WHITE_LABEL")
}

export function compareImprints(left: { name: string; kind?: ImprintKind }, right: { name: string; kind?: ImprintKind }) {
  return compareImprintKinds(left, right) || left.name.localeCompare(right.name, "pt-BR", { sensitivity: "base" })
}

export function sortImprints<T extends { name: string; kind?: ImprintKind }>(imprints: T[]) {
  return [...imprints].sort(compareImprints)
}
